import { render, staticRenderFns } from "./userComments.vue?vue&type=template&id=9cd9abb2"
import script from "./userComments.vue?vue&type=script&lang=js"
export * from "./userComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports